export default __webpack_public_path__ + "static/media/Blog_read_more.0bfea479.jpg";